import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { Icon } from '@liftango/ui-icons';
import { ICON_FALLBACKS } from '../../../../utils/iconFallbacks';
interface EmptyStateProps {
  title?: string;
  body?: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  compact?: boolean;
}

export default function EmptyState({
  title,
  body,
  icon,
  actionLabel,
  onAction,
  compact = false,
}: EmptyStateProps) {
  const { t } = useTranslation('admin');
  const resolvedTitle = title ?? t('analytics.empty.defaultTitle');
  return (
    <Stack
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{
        py: compact ? 3 : 6,
        px: 2,
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      <Box sx={{ color: 'text.disabled', display: 'flex' }}>
        {icon ?? <Icon size={20} d={ICON_FALLBACKS.Inbox} style={{ fontSize: compact ? 32 : 48 }} />}
      </Box>
      <Typography variant={compact ? 'body2' : 'subtitle1'} fontWeight={600} color="text.primary">
        {resolvedTitle}
      </Typography>
      {body && (
        <Typography variant="body2" sx={{ maxWidth: 360 }}>
          {body}
        </Typography>
      )}
      {actionLabel && onAction && (
        <Button size="small" variant="outlined" onClick={onAction} sx={{ mt: 1 }}>
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}
